import API from "@lib/api";
import { IRole, Messages } from "@interfaces";

import { BaseApi } from "./base-api";

export class RolesApi extends BaseApi {
  protected static api = API({ namespace: "Rol" });
  protected static messages: Messages<typeof RolesApi> = {};

  public static async getAll() {
    const filters = await this.api.get<IRole[]>("GetAll");
    return filters.data;
  }

  public static async getById(id: number) {
    const filter = await this.api.get<IRole>(`GetById/${id}`);
    return filter.data;
  }
}
